import {
    Dialog,
    DialogTitle,
    DialogContent,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DataMatrix, EegDataRecord } from "../types";
import { createRawDataMatrix } from "../utils/calculationsUtils";

type RawDataValidationModalProps = {
    open: boolean;
    onClose: () => void;
    title: string;
    eegData?: Array<EegDataRecord>;
};

export const RawDataValidationModal = ({ open, onClose, title, eegData }: RawDataValidationModalProps) => {
    const dataMatrix = eegData && eegData.length > 0 ? createRawDataMatrix(eegData) : (null as unknown as DataMatrix);

    if (!open) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {title}
                <IconButton onClick={onClose} edge="end" aria-label="close">
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>{dataMatrix && <DataTable matrix={dataMatrix} />}</DialogContent>
        </Dialog>
    );
};

const DataTable = ({ matrix }: { matrix: DataMatrix }) => (
    <TableContainer component={Paper} sx={{ maxHeight: "60vh" }}>
        <Table stickyHeader size="small">
            <TableHead>
                <TableRow>
                    <TableCell sx={{ fontWeight: "bold", minWidth: 120 }}>Location</TableCell>
                    {matrix.headers.map((header) => (
                        <TableCell key={header} sx={{ fontWeight: "bold", minWidth: 100 }} align="right">
                            {header}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {Object.keys(matrix.rows).map((location) => (
                    <TableRow key={location}>
                        <TableCell component="th" scope="row">
                            {location}
                        </TableCell>
                        {matrix.headers.map((header) => (
                            <TableCell key={`${location}-${header}`} align="right">
                                {matrix.rows[location][header] || "N/A"}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);
